/* eslint-disable @typescript-eslint/camelcase */
export default {
  upload_button: {
    help_text: 'JPEG, JPG and PNG file types are allowed. The maximum file size is {{megabytes}} MB'
  },
  messages: {
    new_message: {
      reply_hint: 'We typically reply within 2 business days. For more urgent issues, please'
    },
    input: {
      remaining_chars: 'Remaining characters: {{count}}'
    }
  },
  home_testing: {
    schedule_cta: {
      female_text:
        'If you are interested in discussing your at-home test results and your fertility options with a Kindbody provider, please schedule a fertility assessment. You will have a 1:1 consultation with a fertility specialist and personalized plan for your next step.',
      male_text:
        'If you are interested in discussing your at-home test results and your fertility options with a Kindbody Male Fertility Specialist, please schedule a virtual Hormone Panel Consultation. We will work with you to complete a detailed assessment and a male fertility evaluation.',
      button_text: 'Schedule',
      vios_text:
        'If you are interested in discussing your at-home test results and your fertility options with a provider, please schedule an assessment. You will have a 1:1 consultation with a fertility specialist and personalized plan for your next step. If you have already had your first appointment, please reach out to your care coordinator to schedule a follow-up. If this is your first appointment, click on the Schedule button to request a visit.'
    }
  },
  care_team: {
    page: {
      title: 'Your Care Team',
      description:
        'Your team of physicians, nurse practitioners, physician assistants, and endocrinologists caring for you.'
    },
    your_home_market: 'Your home market: {{name}}',
    change_home_market_link_text: 'Need to change the home market? Send us a message!'
  }
};
